(function(){
    'use strict';

    angular
    .module('app')
    .controller('ColorpickermultController', ColorpickermultController)
 
    ColorpickermultController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function ColorpickermultController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.datos = {};
        vm.datos.colores = [];
        
        vm.fieldName = ""

        vm.htmlDecode = function(input){
          var e = document.createElement('div');
          e.innerHTML = input;
          return e.childNodes[0].nodeValue;
        }

        vm.initVars = function(fieldName,value){
        	console.log(value);
            if(value!=""){
                value = vm.htmlDecode(value);
            }
            if(value!=""){
        	   value = JSON.stringify(value);
               value = value.replace(/\\n/g, "");
               value = value.replace(/\\r/g, "");
               value = value.replace(/\\t/g, "");
               value = value.replace(/([^>"]*)"(?=[^<]*>)/g, '$1\\\\"');
        	   value = JSON.parse(value);
        	   vm.datos = JSON.parse(value);
               //console.log(vm.datos);
            }
        	vm.fieldName = fieldName;
        }

        vm.update = function(){
			var json = angular.toJson(vm.datos);
			$timeout(function(){
				$('#'+vm.fieldName+"-jsoncp").val(json).trigger("change");
			});
		}

        vm.addColor = function(){
        	var color = {};
        	color.value = "";
        	vm.datos.colores.push(color);
        	vm.update();
        }

        vm.borrarCp = function(index){
        	vm.datos.colores.splice(index, 1);
        	vm.update();
        }
    }


})();